<label for="phoneNumber" class="form-label" translate="field.phoneNumber"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber"
         [ngClass]="{ 'is-invalid': isInvalid() }"
  />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
